import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { CommonServiceService } from 'src/app/pages/services/common-service.service';


@Component({
  selector: 'app-common-filter',
  templateUrl: './common-filter.component.html',
  styleUrls: ['./common-filter.component.scss']
})
export class CommonFilterComponent implements OnInit, OnChanges {
  @Input() countryData: any = [];
  @Input() isTabChange = false;
  @Input() showCountry = false;
  @Input() removedSectorchip = false;
  @Input() removedCountryChip = false;
  @Input() removedMsmeChip = false;
  @Input() selectedTab = '';
  @Output() resetButton: EventEmitter<any> = new EventEmitter<any>();
  @Output() applyButton: EventEmitter<any> = new EventEmitter<any>();
  @Output() checkedStatus: EventEmitter<any> = new EventEmitter<any>();
  @Output() isCheckedCountry: EventEmitter<any> = new EventEmitter<any>();
  selectedCountry: any = [];
  selectedSectorView: any = [];
  selectedMsme: any = [];
  sectorViewData: any = [];
  sectorData: any = [];
  ipViewData: any = [];
  factoryData: any = [];
  showAllCountry = false;
  showAllsectorView = false;
  showAllSector = false;
  showAllIpView = false;
  showAllFactory = false;
  tempSectorViewData: any = [];
  tempSectorData: any = [];
  filterText: any = {countryview: 'Country Filter', msmeview: 'MSME Filter', sectorview: 'Sector Filter'};

  @ViewChild(MatMenuTrigger) matMenuTrigger: MatMenuTrigger | undefined;
  isApplied = false;
  isActive = true;
  isChangedTab = false;
  countrySwitch: any = -1;
  constructor(private commonService: CommonServiceService) {

  }

  ngOnInit(): void {

  }


  apply(isAuto: boolean = false): void {
    this.selectedCountry = this.countryData.filter((el: any) =>  el?.is_checked);
    this.selectedSectorView = this.sectorViewData.filter((el: any) =>  el?.is_checked);
    this.selectedMsme = this.sectorData.filter((el: any) =>  el?.is_checked);
    this.applyButton.emit({
      countryData: this.selectedCountry,
      sectorViewData: this.selectedSectorView,
      sectorData: this.selectedMsme,
      isAuto
    });
    this.isApplied = true;
    if (this.selectedTab !== 'programview' && !isAuto) {
      this.isChangedTab = true;
    }
    if (this.matMenuTrigger) {

      this.matMenuTrigger.closeMenu();
    }

  }

  ngOnChanges(change: SimpleChanges): void {
    if (change && (change?.countryData?.currentValue || (change?.selectedTab?.currentValue && change?.selectedTab?.currentValue.length))){
        let selectedCountry: any = this.countryData[0];
        if (this.isChangedTab){
          selectedCountry = this.selectedCountry[0];
        }
        const autoSelectEvent: any = { checked: true };
        this.onModuleChange(autoSelectEvent, selectedCountry, 'country', true, true);
    }

    if (change && change?.removedCountryChip?.currentValue){
      this.reset();
    }

    if (change && change?.removedSectorchip?.currentValue){
      this.selectedSectorView.map((ele: any) => ele.is_checked = false);
      this.selectedSectorView = [];
      if (!this.selectedSectorView.length){
      this.selectedMsme.map((ele: any) => ele.is_checked = false);
      this.selectedMsme = [];
      }
      this.apply();
    }

    if (change && change?.removedMsmeChip?.currentValue){
      this.selectedMsme.map((ele: any) => ele.is_checked = false);
      this.selectedMsme = [];
      this.apply();
    }
  }

  reset(): void {
    this.countryData = [];
    this.selectedCountry = [];
    this.sectorViewData = [];
    this.selectedSectorView = [];
    this.sectorData = [];
    this.selectedMsme = [];
    this.resetButton.emit({});
    if (this.matMenuTrigger) {
      this.matMenuTrigger.closeMenu();
    }

  }

  isCheckedModule(module: any): any {
    if (module?.is_checked) {
      module.is_checked = module.is_checked;
    }
    else {
      module.is_checked = module.is_checked;
    }
  }

  onModuleChange(event: any, module: any, type: string, isAuto: boolean = false, isCountryWise: boolean = false): void {
    this.isApplied = false;
    switch (type) {
      case 'country':
        if (event?.checked) {
          this.countryData = this.countryData.map((el: any) => {
            if (module?.id === el?.id || (isAuto && !this.isChangedTab)) {
              el.is_checked = event?.checked;
            }
            return el;
          });
          let selectedMap: any = this.countryData.filter((data: any) => data.is_checked);
          selectedMap = selectedMap.length ? selectedMap.map((data: any) => data.id).join(',') : '';
          if (selectedMap) {
            this.geSectorViewsByCountry(selectedMap, isAuto, true, module?.id);
          }
          this.selectedCountry = this.countryData.filter((el: any) =>  el?.is_checked);
          if (this.selectedTab === 'countryview') {
          this.apply(isAuto);
          }
        }
        else {
          this.countryData = this.countryData.map((el: any) => {
            if (module?.id === el?.id) {
              el.is_checked = event?.checked;
            }
            return el;
          });
          const selectedCountry: any = this.countryData.filter((el: any) => el?.is_checked);
          this.selectedCountry = this.countryData.filter((el: any) =>  el?.is_checked);

          const unCheckCountry = module.id;
          if (selectedCountry?.length) {

            this.sectorViewData = this.sectorViewData.filter((sector: any) => sector.country_id !== unCheckCountry);

            this.sectorData = this.sectorData.filter((sector: any) => sector['sector.country.id'] !== unCheckCountry);
            this.apply(isAuto);
          } else {
            this.sectorViewData = [];
            this.sectorData = [];
          }
        }
        break;

      case 'sectorView':
        if (event?.checked) {
          this.sectorViewData = this.sectorViewData.map((el: any) => {
            if (module?.id === el?.id || (isAuto && !this.isChangedTab)) {
              el.is_checked = event?.checked;
            }
            return el;
          });

          let selectedMap: any = this.sectorViewData.filter((data: any) => data.is_checked);
          selectedMap = selectedMap.length ? selectedMap.map((data: any) => data.id).join(',') : '';
          if (selectedMap) {
            this.getMsmeBySectorViews(selectedMap, isAuto, isCountryWise, module?.id);
          }

        }
        else {
          const dataCheck = this.sectorViewData.filter((ele: any) => ele.is_checked);
          this.sectorViewData = this.sectorViewData.map((el: any) => {
            if (module?.id === el?.id) {
              el.is_checked = event?.checked;
            }
            return el;
          });

          const selectedSectorView = this.sectorViewData.filter((el: any) => el?.is_checked);
          const unChecksectorView = module.id;
          if (selectedSectorView?.length) {
            this.sectorData.forEach((sector: any) => {
                if (sector.sector_id === unChecksectorView) {
                sector.is_checked = false;
                }
            });
          } else {
            this.sectorData = [];
          }

        }
        break;

      case 'sector':
        if (event?.checked) {
          const data = {
            type : 'sector',
            status: true
          };
          this.sectorData = this.sectorData.map((el: any) => {
            if (module?.id === el?.id || (isAuto && !this.isChangedTab)) {
              el.is_checked = event?.checked;
            }
            return el;
          });
          if (this.selectedTab === 'sectorview' && isAuto) {
          this.apply(isAuto);
          }

        }
        else {
          this.sectorData = this.sectorData.map((el: any) => {
            if (module?.id === el?.id) {
              el.is_checked = event?.checked;
            }
            return el;
          });
        }
        break;
      case 'ipView':
        this.ipViewData = this.ipViewData?.map((el: any) => {
          if (module?.id === el?.id) { el.is_checked = event?.checked; }
          return el;
        }) ?? [];
        break;
      case 'factory':
        this.factoryData = this.factoryData?.map((el: any) => {
          if (module?.id === el?.id) { el.is_checked = event?.checked; }
          return el;
        }) ?? [];
        break;
    }
  }

  selectAll(event: any, type: string): void {
    switch (type) {
      case 'country':
        this.showAllCountry = true;

        if (event.checked) {
          this.countryData = this.countryData?.map((el: any) => {
            el.is_checked = event?.checked;
            return el;
          });
          let selectedMap: any = this.countryData.filter((data: any) => data.is_checked);
          selectedMap = selectedMap.length ? selectedMap.map((data: any) => data.id).join(',') : '';
          if (selectedMap) {
            this.geSectorViewsByCountry(selectedMap);
          }

        } else {
          this.countryData = this.countryData?.map((el: any) => {
            el.is_checked = event?.checked;
            return el;
          });
          this.sectorViewData = [];
          this.sectorData = [];
        }
        break;
      case 'sectorView':
        this.showAllsectorView = true;
        if (event.checked) {
          this.sectorViewData = this.sectorViewData?.map((el: any) => {
            el.is_checked = event?.checked;
            return el;
          });
          let selectedMap: any = this.sectorViewData.filter((data: any) => data.is_checked);
          selectedMap = selectedMap.length ? selectedMap.map((data: any) => data.id).join(',') : '';
          if (selectedMap) {
              this.getMsmeBySectorViews(selectedMap);
          }

        } else {
          this.sectorViewData = this.sectorViewData?.map((el: any) => {
            el.is_checked = event?.checked;
            return el;
          });
          this.sectorData = [];
        }
        break;
      case 'sector':
        this.showAllSector = true;
        if (event.checked) {
          const data = {
            type : 'sector',
            status: true
          };
          this.sectorData = this.sectorData?.map((el: any) => {
            el.is_checked = event?.checked;
            return el;
          });
        } else {
          this.sectorData = this.sectorData?.map((el: any) => {
            el.is_checked = event?.checked;
            return el;
          });
        }
        break;
      case 'ipView':
        this.showAllIpView = true;
        this.ipViewData = this.ipViewData?.map((el: any) => {
          el.is_checked = event?.checked;
          return el;
        }) ?? [];
        break;
      case 'factory':
        this.showAllFactory = true;
        this.factoryData = this.factoryData?.map((el: any) => {
          el.is_checked = event?.checked;
          return el;
        }) ?? [];
        break;
    }
  }


  isModuleOver(items: any[], type: string): boolean {
    if (!items) {
      return false;
    }
    if (type === 'country') {
      const checkedItems = this.countryData.filter((country: any) => country.is_checked);
      return checkedItems.length > 0 && checkedItems.length < this.countryData.length;
    }
    else if (type === 'sectorView') {
      const checkedItems = this.sectorViewData.filter((sectorView: any) => sectorView.is_checked);
      return checkedItems.length > 0 && checkedItems.length < this.sectorViewData.length;
    }
    else if (type === 'ipView' && this.ipViewData?.length) {
      const checkedItems = this.ipViewData.filter((i: any) => i.is_checked);
      return checkedItems.length > 0 && checkedItems.length < this.ipViewData.length;
    }
    else if (type === 'factory' && this.factoryData?.length) {
      const checkedItems = this.factoryData.filter((i: any) => i.is_checked);
      return checkedItems.length > 0 && checkedItems.length < this.factoryData.length;
    }
    else {
      const checkedItems = this.sectorData.filter((sector: any) => sector.is_checked);
      return checkedItems.length > 0 && checkedItems.length < this.sectorData.length;
    }
  }

  toggleShowMore(type: string): void {
    switch (type) {
      case 'country': this.showAllCountry = !this.showAllCountry;
                      break;
      case 'sectorView': this.showAllsectorView = !this.showAllsectorView;
                         break;
      case 'sector': this.showAllSector = !this.showAllSector;
                     break;
      case 'ipView': this.showAllIpView = !this.showAllIpView;
                     break;
      case 'factory': this.showAllFactory = !this.showAllFactory;
                      break;
    }
  }

  geSectorViewsByCountry(countryId: string, isAuto: boolean = false, isCountryWise: boolean = false, currentId: any = 0): void {
      this.commonService.sectorNameDetails('', '', countryId).subscribe((res: any) => {
        if (res?.data?.length) {
          if (!isAuto){
            this.countrySwitch = currentId;
          }else{
            this.countrySwitch = -1;
          }
          res?.data.map((data: any) => {
              data.is_checked =  (!isAuto && currentId === data.country_id)  ? true : false;
          });
          this.sectorViewData = [...res?.data];

        }

      }, () => {
        if (this.sectorViewData?.length) {
          const key = 'id';
          this.sectorViewData = [...new Map(this.sectorViewData.map((item: any) =>
            [item[key], item])).values()];
          this.tempSectorViewData = this.sectorViewData;
          const event: any = {checked: true};

          if (this.selectedTab === 'countryview' && isAuto) {
          this.apply(isAuto);
          }
          if (this.selectedTab === 'sectorview') {
        this.apply(isAuto);
          }
          this.toggleShowMore('sectorView');
        }
      });
  }

  getMsmeBySectorViews(sectorViewId: string, isAuto: boolean = false, isCountryWise: boolean = false, currentId: any = 0): void {
      this.commonService.msmeNameDetails('', '', sectorViewId).subscribe((res: any) => {
        if (res?.data?.length) {
          const selectedData: any = this.isChangedTab
            ? JSON.parse(JSON.stringify(this.selectedMsme))
            : JSON.parse(JSON.stringify(this.sectorData));
          let checkedSectors = selectedData.filter((sector: any) => sector.is_checked);
          checkedSectors = checkedSectors?.length ? checkedSectors.map((sector: any) => sector.id) : [];
          res?.data.map((data: any) => {
            data.is_checked = (!isAuto && currentId === data.sector_id) ||
              checkedSectors.includes(data.id) || this.countrySwitch === data['sector.country.id'] ? true : false;
          });
          this.sectorData = [...res?.data];
        }

      }, () => {
        if (this.sectorData?.length) {
          const key = 'id';
          this.sectorData = [...new Map(this.sectorData.map((item: any) =>
            [item[key], item])).values()];
          this.tempSectorData = this.sectorData;

          const event: any = {checked: true};
          const sectorId = this.sectorData.find((sector: any) => sector.is_checked);
          this.onModuleChange(event, sectorId, 'sector', isAuto, isCountryWise);

          if (this.selectedTab === 'sectorview' && isCountryWise) {
        this.apply(isAuto);
          }

          this.toggleShowMore('sector');
        }
      });

  }
  isCountryAllSelect(data: any): boolean {
    return data.every((el: any) => el?.is_checked);
  }

  allowCloseOnClickOut(event: any = {}): void {
    const isCheckedCountry = this.selectedCountry.map((option: any) => option.id);
    const isCheckedSector = this.selectedSectorView.map((option: any) => option.id);
    const isCheckedMsme = this.selectedMsme.map((option: any) => option.id);
    if (!this.isApplied){

      this.countryData.forEach((country: any) => {
        country.is_checked = false;
        if (isCheckedCountry.includes(country.id)) {
        country.is_checked = true;
        }

      });

      this.sectorViewData.forEach((country: any) => {
        country.is_checked = false;
        if (isCheckedSector.includes(country.id)) {
        country.is_checked = true;
        }

      });

      this.sectorData.forEach((country: any) => {
        country.is_checked = false;
        if (isCheckedMsme.includes(country.id)) {
        country.is_checked = true;
        }

      });


    }
  }

  isDisabled(): boolean {
    let isDisabled = false;
    if (this.selectedTab === 'countryview') {
      isDisabled = this.countryData.find((data: any) => data.is_checked) ? false : true;
    }
    if (this.selectedTab === 'sectorview') {
      isDisabled = this.sectorViewData.find((data: any) => data.is_checked) ? false : true;
    }
    if (this.selectedTab === 'msmeview') {
      isDisabled = this.sectorData.find((data: any) => data.is_checked) ? false : true;
    }

    return isDisabled;
  }

}
